import { css } from "lit";


export const linkedinPostStyles = css`
    .linkedin-post {
        position: relative;
        max-width: 504px;
    }
    
    ::slotted(iframe) {
        width: 100%;
        max-height: 400px;
    }

    .linkedin-post--expanded ::slotted(iframe) {
        max-height: initial;
    }
    
    .show-more,
    .show-less {
        text-align: center;
        width: 100%;
        background: linear-gradient(transparent, var(--sbkColorContentBgColorDefault) 35%);
        padding: var(--sbkCoreSpacing4xl) 0 var(--sbkCoreSpacingXsBase) 0;
        position: absolute;
        bottom: 0;
    }
`;
